module.exports = __webpack_public_path__ + "img/supervision_640.c1424533.webp";